import { USE_NEW_LAYOUT } from './constants'
import { getFeatureFromCache } from './util/feature-cache'

const BODY_CLASS = 'vd-body'
const NEW_LAYOUT_CLASS = 'vd-body--new-layout'

export const useNewLayout = getFeatureFromCache(USE_NEW_LAYOUT)

if (useNewLayout) {
  const vBodyEl = document.querySelector(`.${BODY_CLASS}`)

  if (vBodyEl) {
    vBodyEl.classList.add(NEW_LAYOUT_CLASS)
  }
}
